import { Avatar, Box, IconButton, Modal, Tooltip } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import BackButton from '../subcomponents/BackButton';
import ContentLoader from '../subcomponents/ContentLoader';
import ListItemCard from '../subcomponents/ListItemCard';
import PageLayout from '../subcomponents/PageLayout';
import TimetableCalendarDisplay from '../timetable/TimetableCalendarDisplay';
import { deleteTimetableMoments, fetchTimetableComplete, resetTimetableMomentManagementStatus } from './timetableManagementSlice';
import TimetableMomentAddCard from './TimetableMomentAddCard';
import TimetableSelectionAddCard from './TimetableSelectionAddCard';

import EditIcon from '@mui/icons-material/Edit';
import EventNoteIcon from '@mui/icons-material/EventNote';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationModal from '../subcomponents/ConfirmationModal';

export default function TimetableMomentsPage() {
    const dispatch = useDispatch();
    const { id } = useParams();

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { timetableComplete, timetableMomentsDelete } = useSelector((state) => state.management.timetable);

    useEffect(() => {
        dispatch(fetchTimetableComplete(id));
    }, [dispatch]);

    const [openMoment, setOpenMoment] = useState(false);
    const [openSelection, setOpenSelection] = useState(false);
    const [selectedDates, setSelectedDates] = useState(null);

    const callbackModal = () => {
        setOpenMoment(false);
        setOpenSelection(false);
        setSelectedDates(null);
    };

    // Status callback
    useEffect(() => {
        if (timetableMomentsDelete.status === "success") {
            dispatch(resetTimetableMomentManagementStatus());
            dispatch(fetchTimetableComplete(id));
        } else if (timetableMomentsDelete.status === "failed") {
            dispatch(resetTimetableMomentManagementStatus());
        };
    }, [dispatch, timetableMomentsDelete.status, id]);

    const handleDeleteAll = () => {
        dispatch(deleteTimetableMoments(id))
    }

    return (
        <PageLayout
            title={resourceFinal[appLanguage].words.TIMETABLE}
            content={
                <ContentLoader
                    successCondition={timetableComplete.status === 'success'}
                    errorCondition={timetableComplete.status === 'failed'}
                    content={
                        <>
                            <Box sx={{ display: 'flex', width: 1 }}>
                                <Grid container spacing={1} sx={{ width: 1 }}>
                                    <Grid size={12}>
                                        <ListItemCard backgroundStyle={{ height: 1 }}
                                            primaryText={timetableComplete.data?.name}
                                            secondaryText={resourceFinal[appLanguage].words.TIMETABLE}
                                        />
                                    </Grid>
                                    <Grid size={12}>
                                        <ListItemCard backgroundStyle={{ height: 1 }}
                                            primaryText={timetableComplete.data?.description ? timetableComplete.data?.description : "-"}
                                            secondaryText={resourceFinal[appLanguage].words.DESCRIPTION}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ display: 'flex', flex: '1 1 auto' }}>
                                <TimetableCalendarDisplay
                                    timetableMoments={timetableComplete.data?.moments}
                                    status={timetableComplete.status}
                                    handleSelection={setSelectedDates}
                                    timetableId={id}
                                />
                            </Box>
                            <Modal open={openMoment} onClose={callbackModal}>
                                <>
                                    <TimetableMomentAddCard handleClose={callbackModal} timetableId={id} />
                                </>
                            </Modal>
                            <Modal open={openSelection} onClose={callbackModal}>
                                <>
                                    <TimetableSelectionAddCard handleClose={callbackModal} timetableId={id} selectedDates={selectedDates} />
                                </>
                            </Modal>
                        </>
                    }
                />
            } contentRight={
                <>
                    <Tooltip title={resourceFinal[appLanguage].words.ADD} placement="left" arrow>
                        <IconButton onClick={() => setOpenMoment(true)}>
                            <Avatar sx={{ bgcolor: 'secondary.main', p: 0.5 }}>
                                <EditIcon sx={{ color: 'white.main', fontSize: 40 }} />
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={resourceFinal[appLanguage].words.SELECTION} placement="left" arrow>
                        <IconButton onClick={() => setOpenSelection(true)}>
                            <Avatar sx={{ bgcolor: 'secondary.main', p: 0.5 }}>
                                <EventNoteIcon sx={{ color: 'white.main', fontSize: 40 }} />
                            </Avatar>
                        </IconButton>
                    </Tooltip>
                    <Box>
                        <Tooltip title={`${resourceFinal[appLanguage].words.ALL} ${resourceFinal[appLanguage].words.DELETE}`} placement="left" arrow>
                            <Avatar sx={{ bgcolor: 'secondary.main', p: 0.5, m: 1 }}>
                                <ConfirmationModal
                                    iconButton
                                    icon={<DeleteIcon sx={{ color: 'white.main', fontSize: 40 }} />}
                                    message={resourceFinal[appLanguage].messages.DELETE_TIMETABLE_ALL}
                                    confirmAction={handleDeleteAll}
                                />
                            </Avatar>
                        </Tooltip>
                    </Box>
                    <BackButton desktop />
                </>
            }
            bottomBar
        />
    );
}
